import { gql } from '@apollo/client';
import { JobFamiliesModel, JobFamilyModel, JobFamilyGroupModel } from '@utmost.co/enterprise-models';
import {
  CREATE_JOB_FAMILY_MODEL_FRAGMENT,
  PATCH_JOB_FAMILY_MODEL_FRAGMENT
} from '../../../../../../graphql/features/jobFamilies/jobFamilies.fragment';

export interface JobFamily
  extends Pick<JobFamilyModel, 'name' | 'referenceId' | 'status' | 'uid' | 'permissions' | 'summary'> {
  jobFamilyGroup: Pick<JobFamilyGroupModel, 'uid' | 'name'> | null;
}

export interface UseGetAllJobFamilyData {
  jobFamilies: {
    jobFamilies: JobFamily[];
  };
  jobFamilyGroups: Pick<JobFamiliesModel, 'items'>;
}

export const GET_JOB_FAMILIES = gql`
  query GET_JOB_FAMILIES($query: JobFamilyQueryModelInput, $page: PageModelInput) {
    jobFamilies(page: $page, query: $query) {
      items {
        uid
        jobFamilyGroup {
          uid
          name
        }
        name
        referenceId
        permissions
        summary
      }
      offset
      limit
      totalCount
    }
  }
`;

export const CREATE_JOB_FAMILY = gql`
  mutation CreateJobFamily($mutation: JobFamilyCreateModelInput!) {
    jobFamily: createJobFamily(mutation: $mutation) {
      ...JobFamilyModelFragmentForCreate
    }
  }
  ${CREATE_JOB_FAMILY_MODEL_FRAGMENT}
`;

export const PATCH_JOB_FAMILY = gql`
  mutation PatchJobFamily($jobFamilyUid: String!, $jobFamily: JobFamilyPatchModelInput!) {
    jobFamily: patchJobFamily(jobFamilyUid: $jobFamilyUid, jobFamily: $jobFamily) {
      ...JobFamilyModelFragment
    }
  }
  ${PATCH_JOB_FAMILY_MODEL_FRAGMENT}
`;

export const GET_ALL_JOB_FAMILY_DATA = gql`
  query GET_ALL_JOB_FAMILY_DATA($search: String, $limit: Int!, $offset: Int!) {
    jobFamilies(query: { search: $search }, page: { limit: $limit, offset: $offset }) {
      totalCount
      limit
      offset
    }
    jobFamilyGroups(page: { limit: 50000, offset: 0 }) {
      items {
        uid
        name
      }
    }
  }
`;

export const REMOVE_JOB_FAMILY = gql`
  mutation REMOVE_JOB_FAMILY($uid: String!) {
    deleteJobFamily(uid: $uid) {
      uid
    }
  }
`;
